import { render, staticRenderFns } from "./HeaderMenu.vue?vue&type=template&id=42704642&scoped=true"
import script from "./HeaderMenu.vue?vue&type=script&lang=js"
export * from "./HeaderMenu.vue?vue&type=script&lang=js"
import style0 from "./HeaderMenu.vue?vue&type=style&index=0&id=42704642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42704642",
  null
  
)

export default component.exports